import { Component, ElementRef, inject, viewChild } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { AmpRouterEvent } from "@dcc/shared/amplitude";
import { VdsIconAnchorComponent } from "@dcc/vestas-design-system/angular/components/button";
import { VdsIconComponent } from "@dcc/vestas-design-system/angular/components/icon";
import { VdsStatusDot } from "@dcc/vestas-design-system/angular/components/status-dot";
import { VdsTooltipDirective } from "@dcc/vestas-design-system/angular/components/tooltip";
import { AnnouncementsApiStore, BetaFeaturesApiStore } from "@dcc/vestas-online/notification-area/data-access";
import { TranslocoDirective } from "@jsverse/transloco";
import { UserStore } from "@dcc/vestas-online/data-access";

@Component({
    selector: "vo-notifications-header-area",
    templateUrl: "./header-area.component.html",
    host: {
        class: "block"
    },
    imports: [VdsIconComponent, VdsIconAnchorComponent, RouterLink, VdsStatusDot, TranslocoDirective, VdsTooltipDirective, AmpRouterEvent]
})
export class HeaderAreaComponent {
    private router = inject(Router);
    private userStore = inject(UserStore);
    private announcementsStore = inject(AnnouncementsApiStore);
    private betaFeaturesStore = inject(BetaFeaturesApiStore);

    protected readonly loading = this.announcementsStore.loading;
    protected readonly unreadNotifications = this.announcementsStore.unreadNotifications;

    protected readonly popoverPanelTrigger = viewChild("vdsPopoverTriggerBtn", { read: ElementRef });

    constructor() {
        /** Load announcements */
        this.announcementsStore.load(this.userStore.language);

        /** Load beta features */
        this.betaFeaturesStore.load();
    }

    initiateNotificationsArea(): void {
        this.router.navigate([], { queryParams: { sb: true, sbView: "announcements" }, queryParamsHandling: "merge" });
    }
}
